export function getJWTPayload(token: string) {
    const base64Payload = token.split('.')[1];
    if(typeof base64Payload !== 'string') return
    const payload = Buffer.from(base64Payload, 'base64');
    const parsedPayload = JSON.parse(payload.toString());
    return parsedPayload
}